module.exports = __webpack_public_path__ + "img/delete-white.c3138aed.svg";